import { createContext } from 'react';
import type { AuthUser } from '@/api/auth';

export interface Session {
  user: AuthUser;
  /** Реальный размер портфеля менеджера (meta.total /clients). null – не удалось посчитать. */
  portfolioSize: number | null;
  /**
   * Плашка в сайдбаре грузится один раз в RootGate и сама по себе не следит
   * за созданием/удалением клиентов на других страницах — дёргать явно после
   * успешной мутации (см. ClientsPage.tsx/useSubmitWizard.ts).
   */
  refreshPortfolioSize: () => void;
}

export const SessionContext = createContext<Session | null>(null);
